import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';

import { AlertModule } from '@core/components/alert/alert.module';
import { AuthorInfoComponent } from '@core/components/author-info/author-info.component';
import { BookmarkComponent } from '@core/components/bookmark/bookmark.component';
import { MobileModalModule } from '@core/components/mobile-modal/mobile-modal.module';
import { ModalModule } from '@core/components/modal/modal.module';
import { SubscribeComponent } from '@core/components/subscribe/subscribe.component';
import { CoreModule } from '@core/core.module';
import { PipesModule } from '@core/pipes/pipes.module';

import { IconComponent } from '@shared/icon/icon.component';
import { RatingComponent } from '@shared/rating/rating.component';
import { FormatPipeModule } from 'lingo2-ngx-date-fns';
import { OnUiButtonModule, OnUiCardMenuModule, OnUiCoverModule } from 'onclass-ui';
import { UserServiceCardComponent } from './user-service-card.component';

@NgModule({
  declarations: [UserServiceCardComponent],
  imports: [
    LocaleSharedModule,
    CommonModule,
    CoreModule,

    RouterModule,
    ModalModule,
    MobileModalModule,
    PipesModule,
    AlertModule,
    IconComponent,
    OnUiCardMenuModule,
    OnUiCoverModule,
    OnUiButtonModule,
    BookmarkComponent,
    SubscribeComponent,
    RatingComponent,
    FormatPipeModule,
    AuthorInfoComponent,
  ],
  exports: [UserServiceCardComponent],
})
export class UserServiceCardModule {}
